import {
  raterWeightedMean, allRaterWeightedMean, isRaterDone, isAllRaterDone
} from 'cxray-utilities/mbo/calculations';

const isAllRaterClosed = appraisers => appraisers
  .every(appraiser => appraiser?.evaluationClosed === true);

export {
  raterWeightedMean,
  allRaterWeightedMean,
  isRaterDone,
  isAllRaterDone,
  isAllRaterClosed
};
